import request from '@/utils/request';

/**
 * 领取体验金 POST /liyuan-trade/wallet/trial/claim
 * @param {{ amount: number|string }} body
 * @returns {Promise<{ txHash?: string, balance: number|string, mintStatus?: 'pending'|'confirmed' }>}
 */
export function claimTrialFund(body) {
  return request.post(
    '/liyuan-trade/wallet/trial/claim',
    {
      amount: body?.amount,
    },
    {
      timeout: 45000,
    }
  );
}

/**
 * 查询兑换/提现达标条件 GET /liyuan-trade/wallet/trial/withdraw-conditions
 * @param {{ currentWithdrawAmount?: number|string }} [params]
 * @returns {Promise<TrialConditionsVo>}
 */
export function getTrialWithdrawConditions(params = {}) {
  const query = {};
  if (params.currentWithdrawAmount != null && params.currentWithdrawAmount !== '') {
    query.currentWithdrawAmount = String(params.currentWithdrawAmount);
  }
  return request.get('/liyuan-trade/wallet/trial/withdraw-conditions', query);
}
